import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Input, Button, List, Spin, Card, Switch, Flex, Popover } from "antd"; // Importing Ant Design components
import {
  useCreateComplianceMutation,
  useDeleteComplianceMutation,
  useFetchCompliancesQuery,
  useReorderComplianceMutation,
  useUpdateComplianceMutation,
} from "./compliance.service"; // Adjust import to your API
import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { BACKEND_URL, quillFormats, quillModules } from "../../constant";
import ReactQuill from "react-quill";
import "./style.css";

const ComplianceChecklistCreate = () => {
  const { t, i18n } = useTranslation();

  const { type } = useParams();

  const curLanguage = i18n.language;

  const navigate = useNavigate();

  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [newChecklist, setNewChecklist] = useState("");
  const [isInput, setIsInput] = useState(false);
  const [record, setRecord] = useState(false);
  const [isTempSlider, setIsTempSlider] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [checklistData, setChecklistData] = useState([]);
  const [charCount, setCharCount] = useState(0);
  const quillRef = useRef(null);
  const CHARACTER_LIMIT = 1500;

  const {
    data = { data: { compliances: [] } },
    isFetching,
    isSuccess,
    refetch,
  } = useFetchCompliancesQuery(type, {
    refetchOnMountOrArgChange: true,
  }); // Adjust based on your data fetching logic

  const {
    data: { compliances },
  } = data;

  const [createCompliance] = useCreateComplianceMutation();
  const [deleteChecklist] = useDeleteComplianceMutation();
  const [updateChecklist, { isLoading: isUpdateLoading }] =
    useUpdateComplianceMutation();
  const [
    reorderTasks,
    { isSuccess: isReorderSuccess, isLoading: isReorderLoading },
  ] = useReorderComplianceMutation();

  useEffect(() => {
    if (isSuccess) {
      const checklistTempData = compliances.reduce((arr, cur) => {
        arr.push({
          isSection: cur.isSection,
          _id: cur._id,
          taskNumber: cur.taskNumber,
          title: cur.isSection
            ? ""
            : cur[`title_${curLanguage}`] || cur["title"],
          description: cur.isSection ? (
            <div
              style={{ paddingBottom: "10px" }}
              dangerouslySetInnerHTML={{
                __html: cur[`title_${curLanguage}`] || cur["title"],
              }}
            >
              {/* <pre className="compliance-checklist-content">
                {cur["title"][curLanguage] || cur["title"]["default"]}
              </pre> */}
            </div>
          ) : (
            <div className="hothold-check-add-task">
              {cur.isInput && (
                <div style={{ padding: "5px 15px" }}>
                  <Input style={{ background: "transparent" }} />
                </div>
              )}
              {cur.isTempSlider && (
                // <>
                //   <div
                //     style={{
                //       fontSize: "1.5rem",
                //       textAlign: "center",
                //       marginTop: 10,
                //       fontWeight: "bold",
                //     }}
                //   >
                //     {cur.tempSlider.toFixed(1)}
                //     °C
                //   </div>
                //   <Slider
                //     style={{
                //       margin: "0 15px",
                //     }}
                //     styles={{
                //       track: {
                //         background: "transparent",
                //       },
                //       tracks: {
                //         background: `rgb(109, 179, 63)`,
                //       },
                //     }}
                //     min={-30}
                //     max={120}
                //     step={0.1}
                //     value={cur.tempSlider}
                //   />
                // </>
                <div>*RECORD TEMPERATURE*</div>
              )}
              {cur.isDateRecord && (
                <div>*RECORD TIME AND DATE AUTOMATICALLY*</div>
              )}
              <label style={{ cursor: "pointer" }}>
                {cur.isImage &&
                  (cur.imageUrl ? (
                    <img
                      crossOrigin="anonymous"
                      src={`${BACKEND_URL}${cur.imageUrl}`}
                      alt="Uploaded compliance image"
                      style={{
                        objectFit: "cover",
                        border: "1px solid #d9d9d9",
                        borderRadius: "6px",
                        width: "50%",
                        height: "auto",
                      }}
                    />
                  ) : (
                    <div className="upload-photo-button">Upload Photo</div>
                  ))}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      if (e.target.files[0].type.startsWith("image/")) {
                        const formData = new FormData();
                        formData.append("isDateRecord", cur.isDateRecord);
                        formData.append("isInput", cur.isInput);
                        formData.append("isSection", cur.isSection);
                        formData.append("isTempSlider", cur.isTempSlider);
                        formData.append("isImage", cur.isImage);
                        formData.append("image", e.target.files[0]);
                        updateChecklist({ id: cur._id, data: formData });
                      }
                    }
                  }}
                  hidden
                />
              </label>
            </div>
          ),
        });
        return arr;
      }, []);
      setChecklistData(checklistTempData);
    }
  }, [compliances]);

  const handleAddTask = async () => {
    try {
      if (!newChecklist) {
        toast.error("Checklist title cannot be empty");
        return;
      }
      await createCompliance({
        title: newChecklist,
        isInput: isInput,
        isDateRecord: record,
        isTempSlider,
        isSection: false,
        isImage,
        type,
      });
      setNewChecklist("");
      setIsInput(false);
      setRecord(false);
      setIsTempSlider(false);
      setIsImage(false);
    } catch (error) {
      console.log("Failed to create checklist");
    }
  };

  const handleAddSection = async () => {
    try {
      if (!newChecklist) {
        toast.error("Checklist title cannot be empty");
        return;
      }
      await createCompliance({
        title: newChecklist,
        isInput: false,
        isDateRecord: false,
        isTempSlider: false,
        isImage: false,
        isSection: true,
        type,
      });
      setNewChecklist("");
      setIsInput(false);
      setRecord(false);
      setIsTempSlider(false);
      setIsImage(false);
    } catch (error) {
      console.log("Failed to create checklist");
    }
  };

  const handleReorderTask = (orderTask, orderType) => {
    if (orderType === "up" && orderTask.taskNumber !== 1) {
      const tmpTaskUp = compliances.find(
        (item) => item.taskNumber === orderTask.taskNumber - 1
      );
      if (tmpTaskUp) {
        const tmpDataUp = compliances.reduce((arr, cur) => {
          if (tmpTaskUp._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber + 1 });
            return arr;
          }
          if (orderTask._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber - 1 });
            return arr;
          }
          arr.push({ id: cur._id, taskNumber: cur.taskNumber });
          return arr;
        }, []);
        reorderTasks({ type, data: { tasks: tmpDataUp } });
      }
    }
    if (
      orderType === "down" &&
      compliances.filter((item) => item.taskNumber > orderTask.taskNumber)
        .length > 0
    ) {
      const tmpTaskDown = compliances.find(
        (item) => item.taskNumber === orderTask.taskNumber + 1
      );
      if (tmpTaskDown) {
        const tmpDataDown = compliances.reduce((arr, cur) => {
          if (tmpTaskDown._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber - 1 });
            return arr;
          }
          if (orderTask._id === cur._id) {
            arr.push({ id: cur._id, taskNumber: cur.taskNumber + 1 });
            return arr;
          }
          arr.push({ id: cur._id, taskNumber: cur.taskNumber });
          return arr;
        }, []);
        reorderTasks({ type, data: { tasks: tmpDataDown } });
      }
    }
  };

  const handleChange = (html, delta, source, editor) => {
    const text = editor.getText();
    const textLength = text.trim().length;

    if (textLength <= CHARACTER_LIMIT) {
      setNewChecklist(html);
      setCharCount(textLength);
    } else {
      // If user tries to exceed limit, show warning and revert
      if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        quill.root.innerHTML = newChecklist;
      }
    }
  };

  return (
    <Spin spinning={isFetching}>
      <Card
        title={t("Compliance Checklist")}
        style={{ fontSize: "20px" }}
        bordered={false}
        className="opencheck-create-page"
        extra={
          <Flex justify="center">
            <Button type="default" onClick={() => navigate("/compliance")}>
              {t("BACK")}
            </Button>
          </Flex>
        }
      >
        <div className="opencheck-create-page-container">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={newChecklist}
            onChange={handleChange}
            modules={quillModules}
            formats={quillFormats}
          />
          <div style={{ textAlign: "right", fontSize: "14px" }}>{charCount} / 1500</div>
          <div className="opencheck-create-page-container-switch">
            <h4>{t("ADD TEXTBOX")}</h4>
            <Switch value={isInput} onChange={setIsInput} />
          </div>
          <div className="opencheck-create-page-container-switch">
            <h4>{t("RECORD TIME & DATE")}</h4>
            <Switch value={record} onChange={(e) => setRecord(e)} />
          </div>
          <div className="opencheck-create-page-container-switch">
            <h4>{t("ADD TEMPERATURE SLIDER")}</h4>
            <Switch value={isTempSlider} onChange={(e) => setIsTempSlider(e)} />
          </div>
          <div className="opencheck-create-page-container-switch">
            <h4>{t("ADD PHOTO")}</h4>
            <Switch value={isImage} onChange={(e) => setIsImage(e)} />
          </div>
          <div className="opencheck-create-page-container-button">
            <Button
              color="green"
              variant="outlined"
              //   loading={isCreateLoading}
              onClick={handleAddTask}
            >
              {t("Add task to checklist")}
            </Button>
            <Button
              color="green"
              variant="outlined"
              //   loading={isCreateLoading}
              onClick={handleAddSection}
            >
              {t("Add Section")}
            </Button>
          </div>
        </div>

        <List
          className="opencheck-create-page-insight"
          itemLayout="horizontal"
          dataSource={checklistData}
          loading={isUpdateLoading}
          renderItem={(checklist, index) => (
            <List.Item
              className={
                checklist.isSection ? "background-section" : "background-task"
              }
              extra={
                <Popover
                  placement="bottom"
                  content={
                    <div className="opencheck-list-page-tools-popover">
                      <Button
                        color="cyan"
                        variant="solid"
                        style={{ background: "rgb(47, 45, 113)" }}
                        onClick={() => {
                          handleReorderTask(checklist, "up");
                          setOpenPopoverId(null);
                        }}
                      >
                        {t("MoveUp")}
                      </Button>
                      <Button
                        color="cyan"
                        variant="solid"
                        style={{ background: "rgb(47, 45, 113)" }}
                        onClick={() => {
                          handleReorderTask(checklist, "down");
                          setOpenPopoverId(null);
                        }}
                      >
                        {t("MoveDown")}
                      </Button>
                      <Button
                        color="green"
                        variant="solid"
                        icon={<EditOutlined />}
                        onClick={() =>
                          navigate(`/compliance/edit/${checklist._id}`)
                        }
                        size="small"
                      >
                        {t("Edit")}
                      </Button>
                      <Button
                        variant="solid"
                        color="danger"
                        size="small"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                          deleteChecklist(checklist._id);
                          setOpenPopoverId(null);
                        }}
                      >
                        {t("DELETE")}
                      </Button>
                    </div>
                  }
                  open={openPopoverId === checklist._id}
                  onOpenChange={(visible) =>
                    setOpenPopoverId(visible ? checklist._id : null)
                  }
                  trigger="click"
                >
                  <MoreOutlined className="opencheck-list-page-tools-icon" />
                </Popover>
              }
            >
              <List.Item.Meta
                title={
                  checklist.title !== "" ? (
                    <div
                      className="compliance-checklist-content"
                      dangerouslySetInnerHTML={{ __html: checklist.title }}
                    >
                      {/* {checklist.taskNumber}. {checklist.title} */}
                    </div>
                  ) : (
                    ""
                  )
                }
                description={checklist.description}
              />
            </List.Item>
          )}
        />
      </Card>
    </Spin>
  );
};

export default ComplianceChecklistCreate;
